const enum EnvironmentEnum {
  LOCAL = 'local',
  DEV = 'development',
  PROD = 'production',
}

export class Environment {
  private static ENVS = {
    local: process.env.HOST_ROOT.includes('local'),
    dev: process.env.HOST_ROOT.includes('dev'),
    prod: process.env.HOST_ROOT.includes('arbihunter.com'),
  };

  static isDev = () => {
    return Environment.ENVS.dev;
  };

  static isLocal = () => {
    return Environment.ENVS.local;
  };

  static isProd = () => {
    return Environment.ENVS.prod;
  };

  static getEnvironmentName(): EnvironmentEnum {
    if (Environment.isProd()) return EnvironmentEnum.PROD;
    if (Environment.isDev()) return EnvironmentEnum.DEV;
    if (Environment.isLocal()) return EnvironmentEnum.LOCAL;
  }
}
